import ApplicationController from "./application_controller";
import AirDatepicker from "air-datepicker";
import fr from "air-datepicker/locale/fr";
import en from "air-datepicker/locale/en";
import Inputmask from "inputmask";

export default class extends ApplicationController {
  static values = {
    minDate: String,
    maxDate: String,
    reflex: String,
    format: String,
    timepicker: Boolean,
    locale: String,
    name: String,
    id: String,
    disabled: Boolean
  };

  connect() {
    // --- Locale ---
    let selectedLocale = fr;
    if (this.hasLocaleValue && this.localeValue === "en") selectedLocale = en;

    // --- Format date ---
    const finalFormat = this.hasFormatValue
      ? this.formatValue
      : this.localeValue === "en"
      ? "MM/dd/yyyy"
      : "dd/MM/yyyy";


  // --- disabled field ---
    this.isDisabled =
      this.element.hasAttribute("disabled") || // disabled: true dans la vue Rails
      (this.hasDisabledValue && this.disabledValue); // ou via data-date-picker-disabled-value="true"

    if (this.isDisabled) {
      this.element.setAttribute("disabled", "disabled");
    } else {
      this.element.removeAttribute("disabled");
    }

      
    // --- Placeholder selon locale ---
    // if (this.hasFormatValue) {
    //   this.element.placeholder = this.formatValue.toLowerCase();
    // } else if (this.localeValue === "en") {
    //   this.element.placeholder = (this.hasTimepickerValue && this.timepickerValue)
    //     ? "mm/dd/yyyy hh:mm"
    //     : "mm/dd/yyyy";
    // } else {
    //   this.element.placeholder = (this.hasTimepickerValue && this.timepickerValue)
    //     ? "jj/mm/aaaa hh:mm"
    //     : "jj/mm/aaaa";
    // }
    this.element.style.boxSizing = "content-box";
    // --- Parsing bornes ---
    const minDateParsed = this.hasMinDateValue
      ? new Date(this.minDateValue)
      : undefined;
    const maxDateParsed = this.hasMaxDateValue
      ? new Date(this.maxDateValue)
      : undefined;

    // --- Valeur par défaut ---
    const defaultDate = this.element.value
      ? this.parseInputDate(this.element.value, finalFormat)
      : null;

    // --- Forcer affichage correct pour <input type="time"> ---
    if (this.element.type === "time") {
      this.element.type = "text";
    }

    // --- Initialisation AirDatepicker ---
    this.picker = new AirDatepicker(this.element, {
      onlyTimepicker:
        this.element.classList.contains("time-only") ||
        (this.hasTimepickerValue &&
          this.timepickerValue &&
          this.element.dataset.onlyTime === "true"),
      autoClose: true,
      timepicker: this.hasTimepickerValue ? this.timepickerValue : false,
      timeFormat: "HH:mm",
      dateFormat: finalFormat,
      locale: selectedLocale,
      isMobile: false,
      minDate: minDateParsed,
      maxDate: maxDateParsed,
      selectedDates: defaultDate ? [defaultDate] : [],
      view: "days",
      buttons: [
        {
          content: this.localeValue === "en" ? "Today" : "Aujourd’hui",
          className: "custom-today-btn",
          onClick: (dp) => {
            const today = new Date();
            dp.selectDate(today, true);
            dp.setViewDate(today);
          },
        },
        "clear",
      ],
      navTitles: {
        days: "MMMM yyyy",
      },
      prevHtml: "&larr;",
      nextHtml: "&rarr;",
      onSelect: ({ date }) => this.handleSelect(date),
    });

    // --- Créer ou retrouver le champ hidden associé ---
    const existing = document.getElementById(this.idValue);
    if (
      existing &&
      existing.tagName === "INPUT" &&
      existing.type === "hidden"
    ) {
      this.hiddenInput = existing;
    } else {
      this.hiddenInput = document.createElement("input");
      this.hiddenInput.type = "hidden";
      this.hiddenInput.id = this.idValue;
      this.hiddenInput.name = this.nameValue;
      this.element.parentNode.insertBefore(
        this.hiddenInput,
        this.element.nextSibling
      );
    }

    // --- Empêcher le champ visible d'être soumis ---
    this.element.removeAttribute("name");
    this.hiddenInput.name = this.nameValue;

    // --- Valeur initiale du hidden ---
    const parsed = this.parseInputDate(this.element.value, finalFormat);
    this.hiddenInput.value =
      parsed && !isNaN(parsed.getTime()) ? this.toRailsDateFormat(parsed) : "";

    // --- Inputmask (pour format date seulement, pas time-only) ---
    // ✅ Gérer le masque selon le type de champ
    if (this.picker.onlyTimepicker) {
      // Mode "heure seule"
      Inputmask({
        mask: "h9:s9",
        placeholder: "__:__",
        alias: "datetime",
        hourFormat: "24",
        showMaskOnHover: false,
      }).mask(this.element);
    } else if (this.hasTimepickerValue && this.timepickerValue) {
      // Mode "date + heure"
      Inputmask({
        mask: "99/99/9999 99:99",
        placeholder: "__/__/____ __:__",
        showMaskOnHover: false,
      }).mask(this.element);
    } else {
      // Mode "date seule"
      Inputmask({
        mask: "99/99/9999",
        placeholder: "__/__/____",
        showMaskOnHover: false,
      }).mask(this.element);
    }

    // --- Form submit sync ---
    this.form = this.element.closest("form");
    if (this.form) {
      this.submitListener = this.handleFormSubmit.bind(this);
      this.form.addEventListener("submit", this.submitListener);
    }

    // --- Synchroniser quand l'utilisateur saisit manuellement une date ---

    this.element.addEventListener("blur", () => {
  setTimeout(() => {
    const inputValue = this.element.value.trim();
    const inputDate = this.parseInputDate(inputValue, finalFormat);

    // ⚠️ Date invalide
    if (!inputDate || isNaN(inputDate.getTime())) {
      this.element.value = "";
      this.hiddenInput.value = "";
      this.element.classList.add("fx-error");
      setTimeout(() => this.element.classList.remove("fx-error"), 3000);
      return;
    }

    // ✅ Gestion bornes
    if (minDateParsed && inputDate < minDateParsed) {
      if (!isNaN(minDateParsed.getTime())) {
        this.picker.selectDate(minDateParsed, true);
        this.picker.setViewDate(minDateParsed);
        this.hiddenInput.value = this.toRailsDateFormat(minDateParsed);
      }
      return;
    }

    if (maxDateParsed && inputDate > maxDateParsed) {
      if (!isNaN(maxDateParsed.getTime())) {
        this.picker.selectDate(maxDateParsed, true);
        this.picker.setViewDate(maxDateParsed);
        this.hiddenInput.value = this.toRailsDateFormat(maxDateParsed);
      }
      return;
    }

    // ✅ Ajout : gestion de l’heure si timepicker activé
    if (this.hasTimepickerValue && this.timepickerValue) {
      const timeMatch = inputValue.match(/(\d{1,2}):(\d{1,2})/);
      if (timeMatch) {
        const hours = parseInt(timeMatch[1], 10);
        const minutes = parseInt(timeMatch[2], 10);
        inputDate.setHours(hours);
        inputDate.setMinutes(minutes);

        // Si le timepicker existe, on le met à jour visuellement
        if (this.picker.timepicker) {
          if (typeof this.picker.timepicker.setHours === "function") {
            this.picker.timepicker.setHours(hours);
            this.picker.timepicker.setMinutes(minutes);
          } else {
            // fallback pour les versions plus anciennes
            this.picker.timepicker.hours = hours;
            this.picker.timepicker.minutes = minutes;
          }
        }
      }
    }

    // ✅ Met à jour la sélection du calendrier
    const currentSelected = this.picker.selectedDates?.[0];
    if (!currentSelected || currentSelected.getTime() !== inputDate.getTime()) {
      this.picker.selectDate(inputDate, true);
      this.picker.setViewDate(inputDate);
    }

    // ✅ Met à jour le champ caché envoyé à Rails
    this.hiddenInput.value = this.toRailsDateFormat(inputDate);
  }, 10);
});


  }

  // --- Lors de la sélection d’une date/heure ---
  handleSelect(date) {
    if (!date) {
      this.hiddenInput.value = "";
      return;
    }

    // ✅ Conserver la date lors d’un changement d’heure
    if (
      this.hasTimepickerValue &&
      this.timepickerValue &&
      this.picker.selectedDates.length > 0
    ) {
      const prev = this.picker.selectedDates[0];
      if (prev && prev instanceof Date && !this.picker.onlyTimepicker) {
        date.setFullYear(prev.getFullYear());
        date.setMonth(prev.getMonth());
        date.setDate(prev.getDate());
      }
    }

    this.hiddenInput.value = this.toRailsDateFormat(date);

    if (this.hasReflexValue) {
      this.element.dispatchEvent(new CustomEvent("change", { bubbles: true }));
    }
  }

  // --- Parse la valeur entrée ---
  parseInputDate(value, format) {
    if (!value || typeof value !== "string") return null;
    const str = value.trim();

    // Gestion directe des formats ISO
    const isISO = /^\d{4}-\d{2}-\d{2}/.test(str);
    if (isISO) {
      const date = new Date(str);
      if (!isNaN(date)) return date;
    }

    // Détection et découpage selon format
    let day,
      month,
      year,
      hours = 0,
      minutes = 0;
    const dateTimeParts = str.split(" ");
    const datePart = dateTimeParts[0];
    const timePart = dateTimeParts[1] || "";

    const dateParts = datePart.split(/[\/\.\-]/);

    if (format.startsWith("dd")) {
      [day, month, year] = dateParts;
    } else if (format.startsWith("MM")) {
      [month, day, year] = dateParts;
    } else if (format.startsWith("yyyy")) {
      [year, month, day] = dateParts;
    }

    if (timePart) {
      const timeMatch = timePart.match(/(\d{1,2}):(\d{1,2})/);
      if (timeMatch) {
        hours = parseInt(timeMatch[1], 10);
        minutes = parseInt(timeMatch[2], 10);
      }
    }

    if (!day || !month || !year) return null;

    const d = new Date(year, month - 1, day, hours, minutes);
    return isNaN(d.getTime()) ? null : d;
  }
  syncManualInput(format) {
    const inputValue = this.element.value.trim();
    if (!inputValue) {
      this.hiddenInput.value = "";
      this.picker.clear();
      return;
    }

    const parsedDate = this.parseInputDate(inputValue, format);

    if (parsedDate && !isNaN(parsedDate.getTime())) {
      // ✅ Met à jour le calendrier
      this.picker.selectDate(parsedDate, true);
      this.picker.setViewDate(parsedDate);

      // ✅ Met à jour le champ caché
      this.hiddenInput.value = this.toRailsDateFormat(parsedDate);

      this.element.classList.remove("fx-error");
    } else {
      // ⚠️ Effet visuel d’erreur (facultatif)
      this.element.classList.add("fx-error");
      setTimeout(() => this.element.classList.remove("fx-error"), 2000);

      // On garde l’ancien affichage, mais on vide la valeur envoyée
      this.hiddenInput.value = "";
    }
  }

  // --- Convertit vers format Rails (YYYY-MM-DD HH:MM:SS) ---
  toRailsDateFormat(date) {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const hh = String(date.getHours()).padStart(2, "0");
    const mi = String(date.getMinutes()).padStart(2, "0");
    const ss = "00";

    return this.hasTimepickerValue && this.timepickerValue
      ? `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`
      : `${yyyy}-${mm}-${dd}`;
  }

  handleFormSubmit() {
    const format = this.hasFormatValue
      ? this.formatValue
      : this.localeValue === "en"
      ? "MM/dd/yyyy"
      : "dd/MM/yyyy";

    const parsed = this.parseInputDate(this.element.value, format);
    this.hiddenInput.value =
      parsed && !isNaN(parsed.getTime()) ? this.toRailsDateFormat(parsed) : "";
  }

  disconnect() {
    this.picker?.destroy();
    if (this.form) this.form.removeEventListener("submit", this.submitListener);
  }
}
